(function (app, ng) {

    function FieldStatus(responseStatus) {

        //Constructor Function
        function FieldStatus(fieldName) {
            //public fields
            this.fieldName = fieldName;
            this.status = responseStatus.Nothing;
        }

        //public methods
        FieldStatus.prototype.fail = function() {
            this.status = responseStatus.Failed;
        };
        FieldStatus.prototype.succeed = function() {
            this.status = responseStatus.Saved;
        };
        FieldStatus.prototype.invalidate = function() {
            this.status = responseStatus.Invalid;
        };
        FieldStatus.prototype.startSaving = function() {
            this.status = responseStatus.Processing;
        };
        FieldStatus.prototype.clearStatus = function() {
            this.status = responseStatus.Nothing;
        };
        FieldStatus.prototype.typing = function() {
            this.status = responseStatus.Typing;
        };
        FieldStatus.prototype.clearIfTyping = function() {
            if (this.status === responseStatus.Typing) {
                this.status = responseStatus.Nothing;
            }
        };
        FieldStatus.prototype.is = function(status) {
            return this.status.value === status.value;
        }

        //Return FieldStatus Constructor 
        return FieldStatus;

    }

    FieldStatus.$inject = ["responseStatus"];
    app.factory("FieldStatus", FieldStatus);

})(window.app, window.angular); //jshint ignore:line